import { ActionIcon } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface ExpandToggleProps {
  open: boolean;
  name: string;
  onToggle: () => void;
}

export function ExpandToggle({ open, name, onToggle }: ExpandToggleProps) {
  const { t } = useTranslation();
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      aria-expanded={open}
      aria-label={t(open ? "headsetReleases.hideHeadsets" : "headsetReleases.showHeadsets", {
        name,
      })}
      onClick={onToggle}
    >
      <IconChevronRight
        size={16}
        style={{
          transform: open ? "rotate(90deg)" : undefined,
          transition: "transform 120ms",
        }}
      />
    </ActionIcon>
  );
}
